/*eslint-disable*/
import React from 'react';
import { setActiveLanguage } from 'react-localize-redux';
import smIcons from '../../public/images/social.png';

import infoIcon from '../../public/images/info.svg';
import shareIcon from '../../public/images/share.svg';
import embedIcon from '../../public/images/embed.svg';
import speechIcon from '../../public/images/speechbubble.svg';

import { getHrefFb, getHrefTw, getHrefGp } from '../../helper/sharing';

import * as AppActions from '../../modules/App/AppState';
import './header.styl';


const Header = (props) => {
  const onInfoClick = () => {
    props.dispatch(AppActions.setInfoboxMode('info'));
  };

  const onEmbedClick = () => {
    props.dispatch(AppActions.setInfoboxMode('embed'));
  };

  const onSelectLangChanged = (evt) => {
    const langCode = evt.target.textContent === 'ENGLISCH' ? 'en' : 'de';

    window.history.replaceState({}, '', `?lang=${langCode}`);
    props.dispatch(setActiveLanguage(langCode));
  }

  const bgImage = { backgroundImage: `url(${smIcons})` };

  return (
    <div className="ifdw-header">
        <div className="ifdw-header__buttons">
          <div className="ifdw-header__button" onClick={onInfoClick} role="button" tabIndex={0}>
            <img className="icon" src={infoIcon} alt="info icon" />
            <span>{props.translate('header.info')}</span>
          </div>
          <div className="ifdw-header__button ifdw-header__share-button" role="button" tabIndex={0}>
            <img className="icon" src={shareIcon} alt="share icon" />
            <span>{props.translate('header.share')}</span>
            <div className="share-button--rollover">
              <a className="share__link share__facebook" style={bgImage} target="_blank" href={getHrefFb()} />
              <a className="share__link share__google" style={bgImage} target="_blank" href={getHrefGp()} />
              <a className="share__link share__twitter" style={bgImage} target="_blank" href={getHrefTw()} />
            </div>
          </div>
          <div className="ifdw-header__button" onClick={onEmbedClick} role="button" tabIndex={0}>
            <img className="icon" src={embedIcon} alt="embed icon" />
            <span>{props.translate('header.embed')}</span>
          </div>
          {/*<div className="ifdw-header__button" onClick={onSelectLangChanged} role="button" tabIndex={0}>
            <img className="icon" src={speechIcon} alt="speechbubble icon" />
            {props.translate('header.langLabel')}
          </div>*/}
        </div>

      <h1 className="ifdw-header__title">{props.translate('header.main_headline')}</h1>
      <h2 className="ifdw-header__subtitle">{props.translate('header.sub_headline')}</h2>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js